<template>
	<div id="prize" class="page">
		<div class="prize" v-if="prizeList.length">
			<div v-for="item in prizeList">
					<router-link :to="{path:'/prizeinfo',query:{id:item.id}}">
						<div class="prize-list">
							<div class="lft">
								<img v-bind:src="item.prizeimage"/>
							</div>
							<div class="rgt">
								<div class="tit">
									恭喜 {{item.name}} 通过了 {{item.km}} 考试
								</div>
								<div class="detail">
									<span>{{item.create_at}}</span>
									<span>来自教练：{{item.jlname}}</span>
								</div>
							</div>
						</div>
					</router-link>
			</div>
		</div>
		<div class="null-box" v-if="!prizeList.length">
			<i class="iconfont icon-ico_meiyoushuju"></i>
			<p>您还没有奖状呢</p>
		</div>
	</div>
</template>

<script>

import { Toast } from 'we-vue'
export default {
  data () {
    return {
		loaded:false,
		prizeList:[]
	}
  },
  mounted () {
	
  },
  created(){
	this.$app.pr('/api/prize/mine',{
		token:this.$store.state.token
	}).then((res) => {
		this.prizeList = res.data
		console.log(this.prizeList)
	}).catch((res) => {
		//this.$wx.showToast('加载失败1');
	});
  },
  methods: {
		
  },
  filters: {
    pickerValueFilter (val) {
      if (Array.isArray(val)) {
        return val.toString()
      } else {
        return '请选择'
      }
    }
  }
}
</script>

<style scoped>
	#prize{
		background-color:#FFFFFF;
		min-height:100vh;
	}
	img{
		width:100%;
		height:20vw;
	}
	.prize .title{
		line-height:10vw;
		padding:0vw 3vw;
		font-size:4.2vw;
		background-color:#EEEEEE;
		border-bottom:1px solid #CCCCCC;
		margin-bottom:3vw;
	}
	.prize .title:first-child{
		margin-top:0px;
	}
	.prize-list{
		padding:3vw;
		border-bottom:1px solid #DDDDDD;
		display:flex;
		display:-webkit-flex;
	}
	.prize-list .lft{
		width:25vw;
		background-color:red;
	}
	.prize-list .rgt{
		flex:1;
		-webkit-flex:1;
		padding-left:3vw;
		font-size:4vw;
		color:#898989;
	}
	.prize-list .rgt .tit{
		height:14vw;
	}
	.prize-list .rgt .detail{
		font-size:3.6vw;
	}
	.prize-list .rgt .detail span:last-child{
		float:right;
	}
</style>


// WEBPACK FOOTER //
// src/components/Prize.vue